/**
 * Açılır menü içindeki modül ağacı — dar şerit (RailMenu) ve üst menü (TopNavBar) ortak.
 *
 * Alt klasörler AŞAĞI değil YANA açılır (#480): aşağı açılan ağaç paneli uzatıp ekranın
 * altına taşıyordu. Radix alt menüsü çapraz fare hareketinde paneli kapatmıyor (menu aim),
 * sığmayan tarafa kendiliğinden döner ve klavyeyi (→ ← Enter Esc) taşır.
 */
import { cn } from '@/shared/lib/cn';
import type { UserScreenNode } from '@/shared/types/system';
import {
  DropdownMenuItem,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
} from '@/shared/ui/DropdownMenu';
import { isLeaf } from './useMenu';
import { NavIcon } from './NavIcon';

/** Alt ağaçta aktif ekran var mı — üst klasörler vurgulanır ("nerede olduğumu gör"). */
export function holds(node: UserScreenNode, screenId: string | null): boolean {
  return !!screenId && node.children.some((c) => c.screenId === screenId || holds(c, screenId));
}

export function FlyoutItems({
  nodes,
  activeScreenId,
  onOpen,
}: {
  nodes: UserScreenNode[];
  activeScreenId: string | null;
  onOpen: (n: UserScreenNode) => void;
}) {
  return (
    <>
      {nodes.map((c) =>
        isLeaf(c) ? (
          <DropdownMenuItem
            key={c.screenId}
            onSelect={() => onOpen(c)}
            className={cn(
              c.screenId === activeScreenId && 'bg-brand-500/10 text-brand-700 dark:text-brand-400',
            )}
          >
            <NavIcon node={c} className="h-4 w-4 shrink-0" />
            <span className="min-w-0 flex-1 truncate">{c.caption}</span>
          </DropdownMenuItem>
        ) : (
          <DropdownMenuSub key={c.screenId}>
            <DropdownMenuSubTrigger
              className={cn(
                'font-semibold',
                holds(c, activeScreenId) && 'text-brand-700 dark:text-brand-400',
              )}
            >
              <NavIcon node={c} className="h-4 w-4 shrink-0" />
              <span className="min-w-0 flex-1 truncate">{c.caption}</span>
            </DropdownMenuSubTrigger>
            <DropdownMenuSubContent className="max-h-[80vh] w-64 overflow-y-auto">
              <FlyoutItems nodes={c.children} activeScreenId={activeScreenId} onOpen={onOpen} />
            </DropdownMenuSubContent>
          </DropdownMenuSub>
        ),
      )}
    </>
  );
}
